export const enum Segments {
	WidgetPath = 'widgetPath'
}

export const ROUTES = {
	widget: `/control/:${Segments.WidgetPath}`,
	tenantSelect: `/select`,
	unauthorized: '/unauthorized'
};
